/**
 * Service worker only for production builds.
 * In Vite DEV it MUST stay off — otherwise cached assets kill HMR / live edits.
 */
export function registerSW() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // Dev (npm run dev): unregister any leftover SW + clear caches so edits show instantly
  if (import.meta.env.DEV) {
    void (async () => {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
        if (regs.length > 0) {
          console.info('[Bazaarak] Dev mode: service workers unregistered for live reload.');
        }
      } catch (err) {
        console.warn('[Bazaarak] Failed to clear service workers in dev:', err);
      }
    })();
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((error) => {
        console.log('SW registration failed: ', error);
      });
  });
}
